package compose.assets

import androidx.compose.ui.graphics.vector.ImageVector
import compose.assets.svg.*
import kotlin.collections.List as ____KtList

object Svg

private var __All: ____KtList<ImageVector>? = null

val Svg.All: ____KtList<ImageVector>
    get() {
        if (__All != null) {
            return __All!!
        }
        __All = listOf(
            Fullscreen, VideoAlpha, Point_move, PointerMarkSelected, Filter, Pan_horizontal,
            Forum, PointerMarkRegular, Cursor_pointer, Application_brackets_outline,
            Fit_to_screen_outline, Swap_horizontal, Folder_wrench, Arrow_top_left_thick, AdShare,
            Currency_sign, Arrow_split_vertical, Select_group, Weather_partly_snowy_rainy, Flag,
            Refresh, Shield_account, Multimedia, Square_rounded_badge_outline, Sort, BabyChanging,
            Content_save, Eye_outline, File_sign, Battery_10, Controller, Laser_pointer, Wall,
            Arrow_all, FlagHr, Clock_outline, DeleteEmpty, Floor_plan, Map_marker_multiple,
            Shuffle_variant, List_box_outline, Video, Marker, Vector_point_plus, Dots_vertical, Web,
            Shape, Close, Pan_vertical, Battery_100_alert, Palette_swatch_variant, Music_note,
            CursorHand, Battery_90, Arrow_left_right, ShoePrint, Image, Chat_question,
            Human_male_female, Fan, State_machine, Key, PointerParkIcon, FlagBa, Wheelchair,
            Arrow_decision_outline, Cog_play_outline, Relative_scale, Calendar, Chevron_right,
            Chart_line, Minus_thick, Edit, Check, Weather_windy, Sleep, Scheduler, Content_copy,
            Security, File_export_outline, Layers, Label_multiple, Package_up, SwapHorizontal,
            Source_branch, Cards_spade, Cloud_percent_outline, Atm, Volume_high, Plus,
            Calculator_variant_outline, Timer_edit_outline, Email, Palette, FlagGb, Lan, Tag_text,
            Keyboard, Arrow_split_horizontal, Arrow_left, Link_variant, Advertisements, Check_all,
            Hand_back_left, Information_slab_circle_outline, Clock_plus_outline, Database, Menu, Alert,
            Alert_rhombus, FlagCs, Pdf, MoveResize, LogoHorizontal, Logout, Lock_question, Pause,
            Vector_point_minus, Aspect_ratio, Movie_open_play_outline, Location_enter, Calendar_today,
            LogoVertical, Power, Desktop_classic, Text_long, Download, File_question_outline,
            Shield_move, Search, Package_down, Draw_pen, Map, Image_plus, Device, Eye_closed,
            Delete_outline, Triangle, Format_text, Dots_circle, Clock_star, Translate, Www,
            Vector_point_edit, Sack_percent, Route, View_dashboard, Image_edit, Fullscreen_exit,
            Battery_60, Cellphone_arrow_down, FlagSk, FlagBg, FlagPt, FlagFr, FlagIt, FlagEs, FlagDe, ScreenLand, Account, Phone, Chart_timeline, Label,
            Store, Vector_point_select, Chevron_down, Reload, Animation_play, Handshake_outline,
            Content_paste, Grid_large, Temperature_celsius, ScreenPort
        )
        return __All!!
    }
